/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _isEqual from 'lodash/isEqual';
import _isObject from 'lodash/isObject';
import _isNil from 'lodash/isNil';
import _merge from 'lodash/merge';
import _isString from 'lodash/isString';
import _get from 'lodash/get';
import _assign from 'lodash/assign';
import _cloneDeep from 'lodash/cloneDeep';
import { __awaiter, __generator, __decorate } from 'tslib';
import { saveAs } from 'file-saver';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { AjaxBasics } from '../helpers';
import { BasesDetails } from './basesDetails';
import { EnumActionKeys, BasesOptions } from './basesOptions';
import { BasesPagination } from './basesPagination';
import { BasesUtils } from './basesUtils';

/**
 * 基础 控制器
 */

var BasesController =
/** @class */
function () {
  /**
   * 基础 控制器
   * @param options
   */
  function BasesController(options) {
    if (options === void 0) {
      options = {};
    }
    /**
     * 当前控制器 配置
     * @type {IBasesControllerOptions}
     * @memberof BasesController
     */


    this.options = {};
    this.reset(options);
    this.Details = new BasesDetails(this.DetailsOptions);
    this.Pagination = new BasesPagination(this.PaginationOptions);
  }

  Object.defineProperty(BasesController.prototype, "defaultOptions", {
    /**
     * 默认配置
     * @type {IBasesControllerOptions}
     * @memberof BasesController
     * @default basesOptions
     */
    get: function get() {
      return {
        dataKey: BasesOptions.dataKey,
        pagination: BasesOptions.pagination,
        insert: BasesOptions.insert,
        update: BasesOptions.update,
        "delete": BasesOptions["delete"],
        "export": BasesOptions["export"],
        details: BasesOptions.details,
        infinite: BasesOptions.infinite,
        remoteRefresh: BasesOptions.remoteRefresh
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesController.prototype, "DetailsOptions", {
    /**
     * Details 配置 继承了 当前控制器配置
     * @readonly
     * @private
     * @memberof BasesController
     */
    get: function get() {
      return BasesUtils.getDetailsOptions(this.options);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesController.prototype, "PaginationOptions", {
    /**
     * Pagination 配置 继承了 当前控制器配置
     * @readonly
     * @private
     * @memberof BasesController
     */
    get: function get() {
      return BasesUtils.getPaginationOptions(this.options);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesController.prototype, "dataSource", {
    /**
     * 分页数据 dataSource
     * @readonly
     * @memberof [Pagination.Model.value]
     */
    get: function get() {
      return this.Pagination.dataSource;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesController.prototype, "entity", {
    /**
     * 详情数据
     * @readonly
     * @memberof [Model.value]
     */
    get: function get() {
      return this.Details.entity;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 重置 当前对象配置
   * @param options
   * @returns BasesController
   */

  BasesController.prototype.reset = function (options) {
    var _a, _b;

    if (options === void 0) {
      options = _cloneDeep(this.options);
    }

    _assign(this.options, this.defaultOptions, options);

    (_a = this.Details) === null || _a === void 0 ? void 0 : _a.reset(this.DetailsOptions);
    (_b = this.Pagination) === null || _b === void 0 ? void 0 : _b.reset(this.PaginationOptions);
    this.clear();
    return this;
  };
  /**
  * 清理数据
  */


  BasesController.prototype.clear = function () {
    var _a, _b;

    (_a = this.Details) === null || _a === void 0 ? void 0 : _a.clear();
    (_b = this.Pagination) === null || _b === void 0 ? void 0 : _b.clear();
  };
  /**
   * 创建 onLoad AjaxConfig
   * @param AjaxConfig
   * @returns response
   */


  BasesController.prototype.createAjaxConfig = function (configKey, AjaxConfig) {
    var options = this.options;

    var config = _get(options, configKey, _get(options.other, configKey));

    if (_isString(config)) {
      config = {
        url: config
      };
    } // assign 默认配置


    config = _merge({}, _get(this.defaultOptions, configKey), config);
    return _merge({
      target: this.options.target
    }, config, AjaxConfig);
  };
  /**
   * 加载列表数据
   * @param AjaxConfig
   * @returns
   */


  BasesController.prototype.onLoad = function (AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.Pagination.onLoad(AjaxConfig)];
      });
    });
  };
  /**
   * 加载详情数据
   * @param body
   * @param AjaxConfig
   * @returns entity
   */


  BasesController.prototype.onFind = function (body, AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.Details.onLoad(body, AjaxConfig)];
      });
    });
  };
  /**
   * 编辑 一条 数据 存在 dataKey 调用 onUpdate 否则  onInsert
   * @param {T} entity
   * @param {IAjaxConfig} [AjaxConfig]
   * @returns entity
   */


  BasesController.prototype.onEditor = function (entity, AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        AjaxConfig = _assign({
          body: entity
        }, AjaxConfig);

        if (_get(AjaxConfig.body, this.options.dataKey)) {
          return [2
          /*return*/
          , this.onUpdate(entity, AjaxConfig)];
        }

        return [2
        /*return*/
        , this.onInsert(entity, AjaxConfig)];
      });
    });
  };
  /**
   * 插入 一条 数据
   * @param {T} entity
   * @param {IAjaxConfig} [AjaxConfig]
   * @returns entity
   */


  BasesController.prototype.onInsert = function (entity, AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var response;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            AjaxConfig = this.createAjaxConfig(EnumActionKeys.insert, _assign({
              body: entity
            }, AjaxConfig));
            BasesUtils.log(EnumActionKeys.insert, AjaxConfig);
            return [4
            /*yield*/
            , AjaxBasics.request(AjaxConfig)];

          case 1:
            response = _b.sent(); // 远程数据开关

            if (this.options.remoteRefresh) {
              this.Pagination.onRemoteRefresh();
            } else {
              // 只返回 id 则合并数据加入
              if (!_isNil(response) && !_isObject(response)) {
                response = _assign({}, entity, (_a = {}, _a[this.options.dataKey] = response, _a));
              }

              this.Pagination.onInsert(response, true);
            }

            return [2
            /*return*/
            , response];
        }
      });
    });
  };
  /**
   * 修改 一条 数据
   * @param {T} entity
   * @param {IAjaxConfig} [AjaxConfig]
   * @returns entity
   */


  BasesController.prototype.onUpdate = function (entity, AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (_isEqual(entity, _pick(this.entity, _keys(entity)))) {
              BasesUtils.warning(EnumActionKeys.update + " \u6570\u636E\u6CA1\u6709\u66F4\u6539", _cloneDeep(entity), this.entity);
              throw '数据没有更改';
            }

            AjaxConfig = this.createAjaxConfig(EnumActionKeys.update, _assign({
              body: entity
            }, AjaxConfig));
            BasesUtils.log(EnumActionKeys.update, AjaxConfig);
            return [4
            /*yield*/
            , AjaxBasics.request(AjaxConfig)];

          case 1:
            response = _a.sent(); // 远程数据开关

            if (this.options.remoteRefresh) {
              this.Pagination.onRemoteRefresh();
            } else {
              this.Pagination.onUpdate(entity);
            }

            return [2
            /*return*/
            , response];
        }
      });
    });
  };
  /**
   * 删除 数据集
   * @param entitys dataKey 匹配集合中的对应数据 entity | entity.dataKey | Arrar<entity> | Arrar<entity.dataKey>
   * @param AjaxConfig
   * @returns 返回移除元素组成的新数组。
   */


  BasesController.prototype.onDelete = function (entitys, AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            entitys = this.Pagination.getEntitys(entitys);
            AjaxConfig = this.createAjaxConfig(EnumActionKeys["delete"], _assign({
              body: entitys
            }, AjaxConfig));
            BasesUtils.log(EnumActionKeys["delete"], AjaxConfig);
            return [4
            /*yield*/
            , AjaxBasics.request(AjaxConfig)];

          case 1:
            response = _a.sent(); // 远程数据开关

            if (this.options.remoteRefresh) {
              return [2
              /*return*/
              , this.Pagination.onRemoteRefresh()];
            } else {
              this.Pagination.onDelete(AjaxConfig.body ? AjaxConfig.body : entitys);
            }

            return [2
            /*return*/
            , response];
        }
      });
    });
  };
  /**
   * 导出文件
   * @param {IAjaxConfig} [AjaxConfig]
   * @param {string} [filename]
   * @memberof BasesController
   */


  BasesController.prototype.onExport = function (AjaxConfig, filename) {
    return __awaiter(this, void 0, void 0, function () {
      var res, disposition;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            AjaxConfig = this.createAjaxConfig(EnumActionKeys["export"], AjaxConfig);
            BasesUtils.log(EnumActionKeys["export"], AjaxConfig);
            return [4
            /*yield*/
            , AjaxBasics.request(AjaxConfig)];

          case 1:
            res = _a.sent();
            disposition = res.xhr.getResponseHeader('content-disposition');
            /^attachment;\s{0,}filename=(.*)/i.test(disposition);
            saveAs(res.response, decodeURI(RegExp.$1) || filename || Date.now() + ".xls");
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  __decorate([computed], BasesController.prototype, "dataSource", null);

  __decorate([computed], BasesController.prototype, "entity", null);

  BasesController = __decorate([BindAll()], BasesController);
  return BasesController;
}();

export { BasesController };
//# sourceMappingURL=basesController.js.map
